import { useSelector } from "react-redux";

export const useNotification = () => {
    return useSelector((state) => state.notification);
};
